import React from 'react'

const TransactionDetail = () => {
  return (
    <>
      <section>
        <h1>Transaction Detail</h1>
      </section> 
    </>
  )
}

export default TransactionDetail
